import type {paths} from '../openapi/auth.swagger';
import {axiosInstance} from './axiosInstance';

type ValidateOperation = paths['/executor_web/auth/validate']['post'];

export type ValidatePasswordRequestBody = NonNullable<NonNullable<ValidateOperation['requestBody']>['content']['application/json']>;
export interface ValidatePasswordRequest extends ValidatePasswordRequestBody {
	token: string;
}
export type ValidatePasswordResponse = ValidateOperation['responses'][200]['content']['application/json'];
export type ValidatePasswordErrorResponse = ValidateOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/auth/validate` — см. `paths['/executor_web/auth/validate']` в auth swagger */
export function validatePassword(request: ValidatePasswordRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<ValidatePasswordResponse>('auth/validate', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
